var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row service_builder_block" },
    [
      _c(
        "div",
        { staticClass: "col-md-11 col-sm-12 col-lg-11 col-xs-12 p-0" },
        [
          _vm.header.demo_button
            ? _c("div", { staticClass: "col-xs-12 btn-display" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn custom-btn emergo-blue-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("goToVideoAndPlay", 0, $event)
                      },
                    },
                  },
                  [
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.header.demo_button) },
                    }),
                  ]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btn custom-btn emergo-green-button",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.requestPopup()
                      },
                    },
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.header.button))])]
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "desc-subheader text-color-blue col-xs-12 pr-0" },
            [_vm._v(_vm._s(_vm.blocksdata.header_block))]
          ),
        ]
      ),
      _vm._l(_vm.blocksdata.blocks, function (content, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "col-md-12 col-sm-12 col-lg-12 col-xs-12",
            attrs: { id: index + "_smart_builder_block" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "col-md-11 col-sm-12 col-lg-11 col-xs-12 block_smart desc-content",
              },
              [
                _c("div", {
                  staticClass:
                    "col-xs-12 col-sm-5 pl-0 smart-builder-subheader text-color-blue",
                  domProps: { innerHTML: _vm._s(content.header) },
                }),
                content.pricing
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-7 smart-builder-pricing text-color-blue",
                      },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(content.pricing) },
                        }),
                      ]
                    )
                  : _vm._e(),
                _c("div", {
                  staticClass:
                    "col-md-11 col-sm-12 col-lg-11 col-xs-12 p-0 mr-bt-20",
                  domProps: { innerHTML: _vm._s(content.description) },
                }),
                _c(
                  "div",
                  {
                    staticClass: "col-md-12 col-sm-12 col-lg-12 col-xs-12 pl-3",
                  },
                  _vm._l(Math.ceil(content.points.length / 2), function (i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "row m-0" },
                      _vm._l(
                        content.points.slice((i - 1) * 2, i * 2),
                        function (point, index_V) {
                          return _c(
                            "div",
                            {
                              key: index_V,
                              staticClass:
                                "mr-bt-20 col-xs-12 col-sm-6 col-md-6",
                            },
                            [
                              _c("span", {
                                staticClass: "list-item",
                                domProps: { innerHTML: _vm._s(point) },
                              }),
                            ]
                          )
                        }
                      ),
                      0
                    )
                  }),
                  0
                ),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }